import baseApi from "./base"
import { Step1Request, Step1Response } from "./types/step1"
import { Step2Request, Step2Response } from "./types/step2"
import { Step3Request, Step3Response } from "./types/step3"
import { Step4Request, Step4Response } from "./types/step4"
import { ResendOtpRequest, ResendOtpResponse } from "./types/resendOtp"
import { RefreshCaptcha1Request, RefreshCaptcha1Response } from "./types/refreshCaptcha"
import { BaseResponse } from "./types/common"
import { GetCaptcha1Response, GetCaptcha1Request } from "./types/captcha"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getTokenByTckn1: builder.mutation<BaseResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body,
          functionCode: "SPE0007",
          NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF"
        }
      }),
      transformResponse: (response: string) =>  JSON.parse(response)
    }),
    getCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          guid: body.guid,
          TokenSessionId: body.TokenSessionId,
          functionCode: "SPE0007",
          NextTransactionUrl: "Facebook/GtsPortal/GetCaptcha1",
          language: body.language
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    refreshCaptcha: builder.mutation<RefreshCaptcha1Response, RefreshCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          guid: body.guid,
          functionCode: "SPE0007",
          NextTransactionUrl: "Facebook/GtsPortal/RefreshCaptcha1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    step1: builder.mutation<Step1Response, Step1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          guid: body.guid,
          phoneNumberLast4Digit: body.phoneNumberLast4Digit,
          deviceType: body.deviceType,
          captcha: body.captcha,
          NextTransactionUrl: "Facebook/GtsPortal/Step1",
          TokenSessionId: body.TokenSessionId,
          language: body.language
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    resendOtp: builder.mutation<ResendOtpResponse, ResendOtpRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          guid: body.guid,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/GtsPortal/ResendOtp1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    step2: builder.mutation<Step2Response, Step2Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          guid: body.guid,
          otp: body.otp,
          NextTransactionUrl: "Facebook/GtsPortal/Step2",
          TokenSessionId: body.TokenSessionId,
          language: body.language
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    step3: builder.mutation<Step3Response, Step3Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          guid: body.guid,
          partNo: body.partNo,
          fileId: body.fileId,
          NextTransactionUrl: "Facebook/GtsPortal/Step3",
          TokenSessionId: body.TokenSessionId,
          language: body.language
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    step4: builder.mutation<Step4Response, Step4Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          guid: body.guid,
          fileId: body.fileId,
          NextTransactionUrl: "Facebook/GtsPortal/Step4",
          TokenSessionId: body.TokenSessionId,
          language: body.language
        }
      }),
      transformResponse: (response: string, meta: any, args: any) => {
        const resp = JSON.parse(response)
        let isError = false
        if (resp.ErrorMessage && resp.ErrorMessage.length > 0){
          isError = true
        }
        return {...resp, fullContent: args.fileContentArr.join(''), isViewerPage: isError ? false : true}
      }
    })
  })
})

export const {
  useGetTokenByTckn1Mutation,
  useGetCaptchaMutation,
  useRefreshCaptchaMutation,
  useStep1Mutation,
  useResendOtpMutation,
  useStep2Mutation,
  useStep3Mutation,
  useStep4Mutation
} = api

export default api
